const helperMixins = {
    methods: {
        is_null: value => value == null,

        getXrplMessage: function (tecCode) {
            switch (tecCode) {
                case 'tecINSUFFICIENT_FUNDS':
                    return 'Not enough funds available to complete requested transaction.'
                case 'tecXUMM_SIGN_ERROR':
                    return 'Xumm sign request declined.'
                case 'tecCLAIM':
                    return 'Unspecified failure, with transaction cost destroyed.'
                case 'tecDIR_FULL':
                    return 'Your account cannot own any more objects in the ledger.'
                case 'tecDUPLICATE':
                    return 'THis transaction already exists'
                case 'tecEXPIRED':
                    return 'The transaction tried to create an object whose provided Expiration time has already passed.'
                case 'tecINSUF_RESERVE_LINE':
                    return 'The transaction failed because your account does not have enough XRP to create a new trust line.'
                case 'tecINSUFF_FEE':
                    return 'The transaction failed due to insufficient funds XRP to pay the transaction cost.'
                case 'tecNO_ISSUER':
                    return 'The account specified in the issuer field of a currency amount does not exist.'
                case 'tecNO_LINE_REDUNDANT':
                    return 'The transaction failed to set a trust line to its default state'
                case 'tecNO_LINE':
                    return 'The account making the offer does not have a trust line for that asset'
                case 'tecNO_DST':
                    return 'The account on the receiving end of the transaction does not exist.'
                case 'tecNO_DST_INSUF_XRP':
                    return 'The account on the receiving end of the transaction does not exist, and the transaction is not sending enough XRP to create it.'
                default:
                    return 'Error encountered when processing the transaction. Try again!'
            }
        }
    }
}

export default helperMixins
